import { Link } from "react-router-dom";
import { usePageTitle } from "@/lib/content";

export default function CheckoutCancel() {
  usePageTitle("Checkout Cancelled — Sitebound", "Your Sitebound checkout was cancelled.");
  return (
    <div data-testid="checkout-cancel-page" className="blueprint-grid">
      <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 py-24 text-center">
        <div className="mono-label">Checkout cancelled</div>
        <h1 className="font-display mt-4 text-5xl font-extrabold uppercase tracking-tight text-slate-100">
          No charge made
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
          You cancelled before paying — nothing was charged. The pack will be here when you're ready.
        </p>
        <Link
          data-testid="cancel-back-to-pack"
          to="/product/complete-construction-job-seeker-pack"
          className="mt-10 bg-[#FF5500] px-8 py-4 text-sm font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#E04800]"
        >
          Back to the pack
        </Link>
      </div>
    </div>
  );
}
